import { uuid } from '@core/utils/uuid';

const WS_PATH = '/api/code-community-websocket/gwpub/ws';
const MAX_BACKOFF_MS = 64000;

export interface WsBaseRequestData {
  exerciseId: number;
  unitProductId: number;
}

export interface WsIncomingFrame {
  messageId: string;
  type: string;
  code: number;
  message: string;
  data: unknown;
}

/** 计算第 attempt 次重连的等待毫秒数（1s/2s/4s/…最大64s）*/
export function calcBackoffMs(attempt: number): number {
  return Math.min(1000 * Math.pow(2, attempt), MAX_BACKOFF_MS);
}

/** 校验 token 是否有效（非空字符串） */
export function isValidToken(token: string | null | undefined): boolean {
  return typeof token === 'string' && token.length > 0;
}

/** 构造 WebSocket 连接 URL */
export function buildWsUrl(apiBase: string, token: string): string {
  const wsBase = apiBase.replace(/^https?/, 'wss');
  return `${wsBase}${WS_PATH}?token=${token}`;
}

/** 构造请求报文 JSON 字符串 */
export function buildRequestFrame(type: string, data: object = {}): string {
  return JSON.stringify({ messageId: uuid(), type, data });
}

/** 解析入站消息帧，code !== 0 或解析失败时返回 null */
export function parseIncomingFrame(raw: string): WsIncomingFrame | null {
  try {
    const frame = JSON.parse(raw);
    if (typeof frame.code !== 'number' || frame.code !== 0) return null;
    return frame as WsIncomingFrame;
  } catch {
    return null;
  }
}

/** WebSocket 关闭码常量。4001 为被踢下线（待后端最终确认）*/
export const WS_CLOSE_CODE = {
  KICKED: 4001,
} as const;

/** 事件常量（业务使用 WS_EVENT.XXX，不写魔术字符串）*/
export const WS_EVENT = {
  USER_COUNT: 'userCount',
  USER_WALL: 'userWall',
  USER_REWARD: 'userReward',
  USER_TIME: 'userTime',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  KICKED: 'kicked',
} as const;

export type WsEventType = (typeof WS_EVENT)[keyof typeof WS_EVENT];
